exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".department-title[data-v-993af3fc]{font-size:22px;font-weight:500;line-height:1;color:unset;text-transform:unset}.social-deliverable-campaigns[data-v-993af3fc]{width:100%}.department-label[data-v-993af3fc]{color:var(--wf-primary);display:block;font-weight:400;font-size:1em}.plus-button[data-v-993af3fc]{position:relative;top:-4px;right:-10px}", ""]);

// exports
